var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFarms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.2542 26.8125C48.9292 26.325 48.4417 26 47.7917 26C44.2167 26 40.8042 27.625 38.6917 30.55L37.2292 32.5C35.4417 34.6125 32.6792 35.75 29.9167 35.75H25.0417C24.0667 35.75 23.4167 35.1 23.4167 34.125C23.4167 33.15 24.0667 32.5 25.0417 32.5H28.1292C30.7292 32.5 33.1667 30.3875 33.1667 27.7875V27.625C33.1667 26.8125 32.3542 26 31.5417 26V17.7125C37.8792 16.9 42.9167 11.375 42.9167 4.875C42.9167 3.9 42.2667 3.25 41.2917 3.25C37.3917 3.25 33.9792 5.0375 31.5417 7.6375V3.25C31.5417 2.275 30.8917 1.625 29.9167 1.625C28.9417 1.625 28.2917 2.275 28.2917 3.25V12.5125C25.8542 9.9125 22.4417 8.125 18.5417 8.125C17.5667 8.125 16.9167 8.775 16.9167 9.75C16.9167 16.4125 21.9542 21.775 28.2917 22.5875V26H21.6292C15.7792 26 11.0667 28.6 8.4667 32.825L4.0792 39.65C3.7542 40.1375 3.7542 40.7875 4.0792 41.275L8.9542 49.4C9.1167 49.725 9.6042 50.05 9.9292 50.2125C10.0917 50.2125 10.0917 50.2125 10.2542 50.2125C10.5792 50.2125 10.9042 50.05 11.2292 49.8875C17.4042 45.825 24.5542 43.7125 31.8667 43.7125C37.2292 43.7125 42.1042 40.7875 44.7042 36.075L49.0917 28.275C49.4167 27.95 49.4167 27.3 49.2542 26.8125Z",
    fill: "#8BC34A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarms);
export default __webpack_public_path__ + "static/media/farms.721e80f45ea8b95323e03c75589ca163.svg";
export { ForwardRef as ReactComponent };